import React from 'react';

import { FppEspelhoNotaProdutoDetailComp } from './components';

import { ListagemProvider } from 'context/ListagemContext';

export function FppEspelhoNotaProdutoDetail() {
    return (
        <ListagemProvider>
            <FppEspelhoNotaProdutoDetailComp />
        </ListagemProvider>
    );
}
